import { color } from '@my/util'
import { YStack, SimpleText, Image, ActionButton, XStack } from '@my/ui'
import { NotificationIcon } from '../../../components/index'
import images from '../../../assets/images'

export const WelcomeSection = ({ user, profileFullname }) => {
  const fullName = profileFullname || user?.fullName;
  return <XStack style={{padding: '', width: '100%'}}>
    {/* <XStack justifyContent={'space-between'}>
      <XStack $platform-native={{ flexDirection: 'column' }} flexWrap='wrap' gap={5} style={{width: '100%'}}>
        <SimpleText
          color={color.grey}
          fontWeight="700"
          $platform-native={{ fontSize: 17 }}
          $platform-web={{ fontSize: 30 }}
        >
          Welcome to Parity!{fullName ? '' : '!'}
        </SimpleText>
      </XStack>
      <XStack gap={15} display="none" $platform-native={{ display: 'block' }}>
        <NotificationIcon onPress={() => {}} />
        <ActionButton unstyled pressStyle={{ opacity: 0.5 }}>
          <Image src={images.dummyUser} style={{ height: 35, width: 35 }} />
        </ActionButton>
      </XStack>
    </XStack> */}
    <SimpleText
      fontSize={20}
      lineHeight={24}
      color={color.grey}
      fontWeight="400"
      $platform-web={{ fontSize: 20 }}
    >
      {
        fullName ? <><SimpleText
          //fontSize={18}
          color={color.tzaGreen}
          fontWeight="700"
          //$platform-web={{ fontSize: 20 }}
        >
          {fullName}
        </SimpleText>, your </> : <>Your </>
      }
      personal financial revolution has begun!
    </SimpleText>
  </XStack>
};
